import { computed, Ref } from 'vue'
import { useCurrentUser } from '@/common/useCurrentUser'

export function useLocationOwner(locationOwnerId: Ref<string | null>) {
  const currentUserContext = useCurrentUser()

  const isLocationOwner = computed<boolean>(() => {
    return !!(
      locationOwnerId.value &&
      currentUserContext.value?.lineage?.map((l) => l.id).includes(locationOwnerId.value)
    )
  })

  return {
    isLocationOwner,
  }
}
